import styles from "./TextWithTooltip.module.scss"

import React, { useRef, useState } from "react"

interface Props {
  text: string
  // 텍스트에 적용할 스타일(폰트 크기, 굵기 등)
  className?: string
}

// 한 줄로 표시하다 넘치면 ellipsis 처리하고, 잘렸을 때만 hover 시 전체 텍스트를 툴팁으로 보여주는 컴포넌트
export default function TextWithTooltip({ text, className }: Props) {
  const [showTooltip, setShowTooltip] = useState(false)
  const textRef = useRef<HTMLSpanElement>(null)

  const handleMouseEnter = () => {
    const textElement = textRef.current
    if (!textElement) return

    // scrollWidth(잘리지 않았을 때 필요한 전체 폭) > clientWidth(실제 보이는 폭)이면 ellipsis로 잘린 상태
    const isTruncated = textElement.scrollWidth > textElement.clientWidth
    if (isTruncated) setShowTooltip(true)
  }
  const handleMouseLeave = () => setShowTooltip(false)

  return (
    <div className={styles.wrapper}>
      <span
        ref={textRef}
        className={`${styles.text} ${className ?? ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {text}
      </span>
      {showTooltip && <div className={styles.tooltip}>{text}</div>}
    </div>
  )
}
